import { CollapseType } from '@meitu/saas-editor-ui/es/types';
import { checkTypeIsAiPPT, checkTypeIsPPT } from '@meitu/saas-editor-ui/es/utils/stage';
import { useStoreState } from '@/store';
import { IEditorType } from '@/types';
import { checkImageEditor } from '@/utils/common';
import { getMenus } from './config';

export const useMenu = () => {
    // --- store states ---
    const canvasType = useStoreState((state) => state.templateModel.canvasType);
    const posterType = useStoreState((state) => state.recordModel.posterType);
    const customParams = useStoreState((state) => state.sdkModel.customParams);
    const canShowReplaceAiPPTCollapse = useStoreState((state) => state.templateModel.canShowReplaceAiPPTCollapse);

    // --- computed ---
    const editorType = checkImageEditor() ? IEditorType.imageEditor : IEditorType.posterEditor;

    const isNormalPPT = checkTypeIsPPT(canvasType);
    const isAIPPT = checkTypeIsAiPPT(posterType);
    const isPPTMode = isNormalPPT || isAIPPT;

    const hiddenMenus: Array<CollapseType> = (() => {
        const ret = [] as Array<CollapseType>;

        if (customParams && customParams.hideMenus && customParams.hideMenus.length > 0) {
            ret.push(...(customParams.hideMenus as Array<CollapseType>));
        }

        if (isAIPPT && !canShowReplaceAiPPTCollapse) {
            ret.push(CollapseType.TEMPLATE_MENU);
        }

        return ret;
    })();

    const menus = getMenus(editorType, isPPTMode, hiddenMenus);

    return { menus };
};
